module.exports = __webpack_public_path__ + "img/1482760444.0f3eda5f.jpg";